import { render, staticRenderFns } from "./MyLocation.vue?vue&type=template&id=a0413e8c&"
import script from "./MyLocation.vue?vue&type=script&lang=js&"
export * from "./MyLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports